import { Box, Table, TableHead, TableCell, TableRow, TableBody, Divider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React, { useEffect } from 'react';
import { useAsync } from 'react-async-hook';
import { match } from 'react-router-dom';
import { httpGet, modelQueryUrl, httpPost } from '../../api/http';
import { Activity, ExpectedInbound } from '../../api/models';
import { localeFormatDateTime } from '../../providers/modal/locale';
import Preloader from '../../shared/Preloader';
import RemoteItems from '../../shared/RemoteItems';
import { SummaryList, SummaryListItem } from '../../shared/SummaryList';
import { SwitchBottomNavigation, SwitchBottomNavigationCase } from '../../shared/SwitchBottomNavigation';
import { isExpectedInboundFinished } from '../../services/expectedInboundService';
import { setApplicationTitle } from '../../providers/app';
import { translate } from '../../providers/locale';
import ExpectedInboundStateInline from '../../desktop/controls/ExpectedInboundStateInline';
import { withRouteTitle } from '../../helpers/withRouteTitle';
import browserHistory from '../../browserHistory';

const ExpectedInboundDetailPage: React.FC<{ match: match<any> }> = ({ match }) => {
	const { result: expectedInbound } = useAsync(() => httpGet<ExpectedInbound>(`/expected-inbounds/${match.params.id}`), []);

	useEffect(() => {
		// setApplicationTitle(expectedInbound?.documentNumber);
	}, [expectedInbound]);

	const handleStart = async () => {
		let result = await httpPost(`/wt/expected-inbounds/${expectedInbound.id}/start`);

		result && browserHistory.push(result.navigateTo);
	};

	return (
		<Preloader loading={expectedInbound == null} content={() => (
			<SwitchBottomNavigation>
				<SwitchBottomNavigationCase label="Detail" icon="assignment">
					<Box p={1}>
						<SummaryList>
							<SummaryListItem label="Číslo dokladu">{expectedInbound.documentNumber}</SummaryListItem>
							<SummaryListItem label="Stav">
								<ExpectedInboundStateInline state={expectedInbound.state} />
							</SummaryListItem>
						</SummaryList>
						<Box mt={2}>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell>SKU</TableCell>
										<TableCell>Paleta</TableCell>
										{/* <TableCell>Hotovo</TableCell> */}
										<TableCell>Zbývá</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{expectedInbound.items
										.map(item => (
											<TableRow key={item.id}>
												<TableCell>{item.sku.name}</TableCell>
												<TableCell>{item.palette?.number}</TableCell>
												{/* <TableCell>{item.completeQuantity}</TableCell> */}
												<TableCell>{item.remainingQuantity}</TableCell>
											</TableRow>
										))}
								</TableBody>
							</Table>
						</Box>
						{
							isExpectedInboundFinished(expectedInbound) == false && (
								<Button variant="contained" color="primary" fullWidth={true} onClick={handleStart}>Zpracovat doklad</Button>
							)
						}
					</Box>
				</SwitchBottomNavigationCase>

				<SwitchBottomNavigationCase label="Události" icon="list">
					<List>
						<RemoteItems
							endpoint={modelQueryUrl<Activity>('/activities', {
								modelName: { equals: 'ExpectedInbound' },
								modelId: { equals: expectedInbound.id }
							})}
							each={(item: Activity) => (
								<ListItem key={item.id}>
									<ListItemText primary={(
										<div>{localeFormatDateTime(item.createdAt)} | {item.identity.name}</div>
									)} secondary={item.message} />
								</ListItem>
							)} />
					</List>
				</SwitchBottomNavigationCase>
			</SwitchBottomNavigation>
		)}>
		</Preloader>
	);
}

export default withRouteTitle(ExpectedInboundDetailPage, 'Očekávaný příjem');
